import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ConfigurationService } from '@urbannex/configuration';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EditorTemplateService {
  baseUrl: string;

  constructor(
    private http: HttpClient,
    private configurationService: ConfigurationService,
    @Inject('env') private env) {
    this.baseUrl = env.apiUrl + "/";
  }

  getTemplate(contentId: string): Observable<any> {
    console.log(contentId);
    // let url:string = this.baseUrl+'widgets/form/value/BlogEntries?location=component://kwikstore/widget/WebsiteContentForms.xml&blogContentId='+blogContentId;
    const url: string = this.baseUrl + 'section/' + contentId;
    // let url:string = this.baseUrl+"getBlogEntriesList";
    const urlconfig = {};
    const options = { params: urlconfig, withCredentials: false };
    return this.http.get<any>(url, options)
      .pipe(
        map(resp => {
          // this.orderView = resp;
          return resp;
        })
      );
  }
}
